import { render, staticRenderFns } from "./MarketplaceActivityList.vue?vue&type=template&id=94b94fb4&scoped=true&"
import script from "./MarketplaceActivityList.vue?vue&type=script&lang=js&"
export * from "./MarketplaceActivityList.vue?vue&type=script&lang=js&"
import style0 from "./MarketplaceActivityList.vue?vue&type=style&index=0&id=94b94fb4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94b94fb4",
  null
  
)

export default component.exports